var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermostatWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_195978129266939273486009914442624356345",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFDC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hinava_random_uuid_80029980197038852580106286547828643806",
    width: "162%",
    height: "162%",
    x: "-31%",
    y: "-31%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 9,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_223777138643691163102548086338558544562",
    d: "M70.139 80.139c28.708-28.708 74.013-30.703 105.027-5.984l15.888-5.296c.524-.174 1.09.109 1.265.633.069.205.069.427 0 .632l-5.25 15.75c25.533 31.034 23.798 76.982-5.208 105.987-30.851 30.852-80.871 30.852-111.722 0-30.852-30.851-30.852-80.871 0-111.722z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-13 -23)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#hinava_random_uuid_80029980197038852580106286547828643806)",
    xlinkHref: "#hinava_random_uuid_223777138643691163102548086338558544562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    stroke: "url(#hinava_random_uuid_195978129266939273486009914442624356345)",
    strokeWidth: 4,
    d: "M175.556 71.917c-15.831-12.273-35.165-17.869-54.19-16.785-19.16 1.091-38.005 8.955-52.642 23.592C52.908 94.541 45 115.27 45 136c0 20.73 7.908 41.46 23.724 57.276C84.541 209.092 105.27 217 126 217c20.73 0 41.46-7.908 57.276-23.724 14.799-14.8 22.674-33.9 23.626-53.278.944-19.213-4.92-38.698-17.59-54.532l4.904-14.71c.206-.615.206-1.28 0-1.897-.261-.786-.817-1.39-1.504-1.734-.687-.344-1.504-.425-2.29-.163l-14.866 4.955z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostatWheel);
export default __webpack_public_path__ + "static/media/thermostat-wheel.db671999d6e82ab0183abadc493e0ccb.svg";
export { ForwardRef as ReactComponent };